import { gql } from '@apollo/client';
import {
  TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT,
} from '../../../../../core/graphql/tags';

export const NOTE_TAG_HIGHLIGHTS_FRAGMENT = gql`
  fragment NoteTagHighlights on TestSessionNote {
    tagHighlights {
      ...TagHighlightWithTag
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const TEST_SESSION_NOTES = gql`
  query TestSessionNotes (
    $companyId: ID!,
    $noteType: TestSessionNotesEnum!,
    $limit: Int!,
    $offset: Int!,
    $order: String!,
    $search: String
  ) {
    testSessionNotes(
      companyId: $companyId,
      noteType: $noteType,
      limit: $limit,
      offset: $offset,
      order: $order,
      search: $search
    ) {
      id
      videoUrl
      status
      note
      createdAt
      videoStartTime
      videoEndTime
      testSession {
        id
        tester {
          id
          user {
            id
            profile {
              id
              firstName
            }
          }
          project {
            id
            name
          }
        }
      }
      createdBy {
        id
        profile {
          id
          firstName
        }
      }
      ...NoteTagHighlights
    }
  }
  ${NOTE_TAG_HIGHLIGHTS_FRAGMENT}
`;
